import { useQuery } from "@tanstack/react-query";
import { axiosCoreInstance } from "src/config/axios";
import { UserInvitationModel } from "../../types/UserInvitation";

export const RQ_USER_INVITATION_LIST_KEY = "USER_INVITATION_LIST";

export type UserInvitationListResponse = UserInvitationModel[];

export const fetchUserInvitationList = async (): Promise<UserInvitationListResponse | null> => {
    const { data }: { data: UserInvitationListResponse } =
        await axiosCoreInstance.get(`api/user/invitation`);

    return data || null;
};

export const useUserInvitationList = () => {
    return useQuery({
        queryKey: [RQ_USER_INVITATION_LIST_KEY],
        queryFn: fetchUserInvitationList,
        enabled: false,
    });
};
